export class PopperJSModifiers {
  static flipModifier(block: boolean) {
    return {
      name: 'flip',
      options: {
        fallbackPlacements: !block
          ? ['bottom-end', 'bottom-start']
          : ['top-start', 'bottom-end', 'top-end'],
      },
    };
  }

  static preventOverflowModifier(block: boolean) {
    return {
      name: 'preventOverflow',
      options: { altAxis: true, padding: 8, tether: false },
      enabled: !block,
    };
  }
}
